export function isInDevToolsEnvironment() {
  const url = window.location.toString();
  return !process.env.PRODUCTION && (url.includes('localhost') || url.includes('develop'));
}
